// This file is auto-generated during build. Do not edit.

export interface Scan2SellConfig {
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_JAMS_FRONTEND_URL: string;
  VITE_INVENTORY_API: string;
  VITE_JAMS_QR_API: string; // env-only
  VITE_UPLOAD_SERVICE_API_BASE_URL: string;
  VITE_COMPONENTS_BUCKET_NAME: string;
}

export const config: Scan2SellConfig = {
  VITE_CDN_URL: "https://d1uk0lzwvlv9i9.cloudfront.net",
  VITE_CDN_ID: "E3R5CF6S70BJPT",
  VITE_JAMS_BACKEND_URL: "https://u4mchhy7h3.execute-api.us-west-2.amazonaws.com/qa",
  VITE_JAMS_FRONTEND_URL: "https://jams.admin.qa.sodasoft.io",
  VITE_INVENTORY_API: "https://t62e4qir64.execute-api.us-west-2.amazonaws.com/dev",
  VITE_JAMS_QR_API: "https://snuq569av0.execute-api.us-west-2.amazonaws.com/qa/qr",
  VITE_UPLOAD_SERVICE_API_BASE_URL: "https://y0hajprsih.execute-api.us-west-2.amazonaws.com",
  VITE_COMPONENTS_BUCKET_NAME: "jazel-lightning-components-qa",
};
